(() => {
  const modal = document.querySelector('#sizeGuide');
  if (!modal) return; // modal must be present on the page

  const closeEls = modal.querySelectorAll('[data-sg-close]');
  const table = modal.querySelector('#sg-table');
  const unitLabel = modal.querySelector('#sg-unit-label');
  const tabIn = modal.querySelector('#sg-in');
  const tabCm = modal.querySelector('#sg-cm');
  let unit = 'in';

  // ---- open/close helpers ----
  const open = () => { modal.setAttribute('open',''); modal.removeAttribute('aria-hidden'); tabIn?.focus(); };
  const close = () => { modal.removeAttribute('open'); modal.setAttribute('aria-hidden','true'); };

  // ✅ Event delegation: works even if the filter header is re-rendered
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sg-open="#sizeGuide"]');
    if (trigger) { e.preventDefault(); open(); }
    if (e.target.closest('[data-sg-close]') || e.target === modal.querySelector('.sg-backdrop')) {
      e.preventDefault(); close();
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.hasAttribute('open')) close(); });

  const round1 = n => (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/,'');
  const render = () => {
    table.querySelectorAll('[data-in]').forEach(td => {
      const inches = parseFloat(td.getAttribute('data-in'));
      if (unit === 'in') {
        td.textContent = inches + '"';
      } else {
        let cm = td.getAttribute('data-cm');
        if (!cm) { cm = round1(inches * 2.54); td.setAttribute('data-cm', cm); }
        td.textContent = cm + ' cm';
      }
    });

    if (unit === 'in') {
      unitLabel.textContent = 'inches';
      modal.querySelector('#sg-next-unit')?.replaceChildren('CM');
      modal.querySelector('#sg-next-unit-long')?.replaceChildren('centimeters');
    } else {
      unitLabel.textContent = 'centimeters';
      modal.querySelector('#sg-next-unit')?.replaceChildren('INCHES');
      modal.querySelector('#sg-next-unit-long')?.replaceChildren('inches');
    }

    tabIn?.setAttribute('aria-selected', unit === 'in');
    tabCm?.setAttribute('aria-selected', unit === 'cm');
  };

  tabIn?.addEventListener('click', () => { unit = 'in'; render(); });
  tabCm?.addEventListener('click', () => { unit = 'cm'; render(); });

  render();
})();
